export default __webpack_public_path__ + "4ff7b571f2820931a1b74a12a8c61062.png";